import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { GuestTitle } from 'src/app/shared/constants/commonenums';
import { SurveyApiService } from '../survey-api.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeService } from 'src/app/shared/services/localize.service';
import { LocalizedDatePipe } from 'src/app/shared/pipes/localize-date.pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'activity-summary',
    templateUrl: './activity-summary.component.html',
    styleUrls: ['./activity-summary.component.scss'],
    standalone: false
})
export class ActivitySummaryComponent implements OnInit, OnChanges {

  @Input() getsurveyelement: any;
  @Input() isdatavalid: any;
  @Input() isvalid: any;
  @Input() commentcardStyles: any;
  IntroText: any;
  _input: any;
  descriptionHtml: any;
  constructor(private httpSurveyApi: SurveyApiService, private ts: TranslateService, private ls: LocalizedDatePipe, private sanitizer: DomSanitizer) {
    //ts.use('en');
  }

  ngOnInit() {
    console.log(this.getsurveyelement);
  }


  ngOnChanges() {
    console.log(this.ts.instant('CommentCardBody'));
    this._input = this.getsurveyelement;
    if (this._input) {
      this.descriptionHtml = this._input?.Payload?.FeedbackReservationSummary ? 
        this.sanitizer.bypassSecurityTrustHtml(this._input?.Payload?.FeedbackReservationSummary) : '';
      this.ts.get('CommentCardBody', {
        Title: this.getvalue(this._input?.currentGuest?.GuestTitle),
        FirstName: this._input?.currentGuest?.FirstName,
        LastName: this._input?.currentGuest?.LastName ?? '',
        ActivityName: this._input?.Payload?.SpecialMealName ?? this.ts.instant('CommentCardBooking'),
        OutletName: this._input?.currentGuest?.VisitStats[0].RestaurantName,
        DateandTime: this._input?.Payload?.BookedDates?.length ? (this._input?.Payload?.BookedDates?.map(date => this.ls.transform(date, 'dddd, MMMM D')).join(', ')) :
          ((this._input?.Payload?.ReservedFor && this.ls.transform(this._input?.Payload?.ReservedFor, 'dddd, MMMM D')) ||
            (this._input?.Payload?.ArrivedAt && this.ls.transform(this._input?.Payload?.ArrivedAt, 'dddd, MMMM D')))
      }).subscribe(result => {
        this.IntroText = result;
      });
    }
  }

  /* public getTokens():any {
    this.httpSurveyApi.getTokens().subscribe((response:any) => {
      
    this.getsurveyelement = response;
    console.log(typeof response);
    console.log(typeof this.getsurveyelement);
     console.log(this.getsurveyelement, 'getsurveyelement');
     
      
    }, error => {
      console.log(error);
    })
  }*/
  getvalue(val) {
    return (val > 0) ? GuestTitle[val] + "." : "";
  }

}
